import { css } from "@compiled/react";
import { FormattedMessage, useIntl } from "react-intl";

import Heading from "@atlaskit/heading";
import { token } from "@atlaskit/tokens";

import { Link } from "@/libraries/design/components";
import { wacToken } from "@/libraries/design/foundations";

import { messages } from "./messages";

const headerStyles = css({
    textAlign: "center",
    marginInline: "auto"
});

const titleStyles = css({
    fontFamily: wacToken("font.charlie.display")
});

const subtitleStyles = css({
    fontFamily: wacToken("font.charlie.text"),
    fontSize: "18px",
    lineHeight: "28px",
    color: wacToken("color.neutral.light700"),
    marginBlockStart: token("space.200")
});

export const PageHeader = () => {
    const intl = useIntl();
    return (
        <header css={headerStyles}>
            <Heading size="xlarge" as="h2">
                <span css={titleStyles}>
                    <FormattedMessage {...messages.title} />
                </span>
            </Heading>
            <p css={subtitleStyles}>
                <FormattedMessage
                    {...messages.subtitle}
                    values={{
                        learnMoreLink: (
                            <Link
                                type="inline"
                                showArrow={false}
                                showUnderline={false}
                                aria-label={intl.formatMessage(
                                    messages.moreAboutRovoUsage
                                )}
                                text={intl.formatMessage(
                                    messages.moreAboutRovoUsage
                                )}
                                href="/software/rovo/pricing/usage-based-pricing"
                            />
                        )
                    }}
                />
            </p>
        </header>
    );
};
